export default ({
  pageState: { editorAdders, editorBlocks, editorBlocksOrder },
  data: { blockIds }
}) => {
  return {
    editorAdders: editorAdders.slice(0, -1 * blockIds.length).map(() => false),
    editorBlocks: Object.keys(editorBlocks).reduce((blocks, id) => {
      if (!blockIds.includes(id)) blocks[id] = editorBlocks[id];
      return blocks;
    }, {}),
    editorBlocksOrder: editorBlocksOrder.filter((id) => !blockIds.includes(id)),
    editorHeaderStatus: 'saving'
  };
};
